import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TChatHeaderUserCardButton = {
  onClick: () => void;
};

export const ChatHeaderUserCardButton: React.FC<TChatHeaderUserCardButton> = ({ onClick }) => {
  return (
    <a className={styles['arrow']} data-testid="ChatHeaderUserCardButton">
      <IconActionChevronRight12 onClick={onClick} color="icon-secondary-default" />
    </a>
  );
};
